export default function PillarOverview({ pillars }) {

  const scrollToPillar = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <section className="relative w-full py-16 px-6 md:px-12 bg-gradient-to-b from-black/30 to-black/10 overflow-hidden">
      {/* Background decorative shapes */}
      <div className="absolute -top-16 -left-16 w-64 h-64 bg-cyan-500/20 rounded-full blur-3xl animate-pulse-slow"></div>
      <div className="absolute -bottom-20 -right-20 w-80 h-80 bg-purple-500/20 rounded-full blur-3xl animate-pulse-slow"></div>

      <div className="relative max-w-7xl mx-auto flex flex-col items-center gap-12">
        {/* Section Heading */}
        <div className="text-center max-w-4xl space-y-4">
          <h2 className="text-white text-3xl md:text-4xl font-bold drop-shadow-lg">
            Four Pillars of Peak Performance
          </h2>
          <p className="text-gray-300 text-base md:text-lg drop-shadow-sm">
            Each pillar contributes to complete athletic development and long-term health. Explore each to unlock your peak potential.
          </p>
        </div>

        {/* Pillar Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 w-full">
          {pillars.map((pillar, idx) => (
            <div
              key={idx}
              onClick={() => scrollToPillar(pillar.id)}
              className="cursor-pointer relative block rounded-2xl p-8 bg-gradient-to-br from-black/40 to-black/20 border border-gray-500 shadow-lg transform transition duration-500 hover:scale-105 hover:shadow-2xl hover:from-cyan-500/30 hover:to-purple-500/20 group overflow-hidden"
            >
              {/* Accent overlay for hover effect */}
              <div className="absolute inset-0 bg-gradient-to-tr from-transparent to-white/10 opacity-0 group-hover:opacity-20 transition duration-500 rounded-2xl"></div>

              <h3 className="text-white text-xl md:text-2xl font-bold mb-2 relative z-10">
                {pillar.title}
              </h3>
              <p className="text-gray-300 text-sm md:text-base relative z-10">
                {pillar.subtitle || "Click to explore"}
              </p>

              {/* Animated floating circle */}
              <div className="absolute -top-4 -right-4 w-12 h-12 border-2 border-cyan-400 rounded-full opacity-30 animate-pulse-slow"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
